import { atom } from 'jotai';

export const isFAQModalOpenAtom = atom(false);
export const isInfoModalOpenAtom = atom(false);
export const isSettingsModalOpenAtom = atom(false);
